export default "__VITE_ASSET__57470855__"